import React , { useState, useEffect } from 'react';
import { Filter, TextInput, SelectInput, useDataProvider,AutocompleteInput } from 'react-admin';
import { InputAdornment } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { evidenceType, status } from '../../utils/choices';

const EvidenceFilters = (props) => {
  const [plots, setPlots] = useState([]);

  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getList('plot', {})
      .then(({ data }) => {
        const plotArray = data.map(({ id, name }) => ({ id, name }));
        setPlots(plotArray);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <Filter {...props}>
      <TextInput
        alwaysOn
        source="name"
        label="Evidence name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
        }}
      />

      <SelectInput source="type" choices={evidenceType} alwaysOn allowEmpty />
      <SelectInput source="status" choices={status} alwaysOn allowEmpty />
      {/* <SelectInput source="plotId" choices={plots} alwaysOn allowEmpty /> */}
      <AutocompleteInput 
        source="plotId" 
        choices={plots} 
        shouldRenderSuggestions = {(val) =>  val.trim().length > 0 }
        alwaysOn 
        allowEmpty
      />
    </Filter>
  );
};

export default EvidenceFilters;
